/**
 * $.uiFareremark() plugin.
 *
 * Открывает модалку с УПТ(условиями применения тарифа)
 *
 * Options:
 *     header_title:                           string (default: $.sa.locales['fare_rules']) - Заголовок модалки
 *     content:                                string (default: `<i class="fa fa-spinner fa-spin"></i>`) - Прелоадер, который будет отображаться, пока грузятся данные
 *
 *     order_hash                              string (Обязательный, если search_hash пустой) - Хэш заказа
 *     order_passenger_hash                    string (optional) - Хэш пассажира (для групповых заказов)
 *     search_hash:                            string (optional) - Хэш, который состоит из [search_params_hash-variant_price_hash-control-sign]
 *     exchange_pricing_passenger_hashes       string (optional) - Хэш выбранных пассажиров
 *     exchange_pricing_segment_hash           string (optional) - Хэш выбранного сегмента
 *     exchange_pricing_desired_date           string (optional) - Дата желаемого рейса
 *     exchange_pricing_desired_variant_hash   string (optional) - Хэш желаемого сегмента
 */
(function ($) {

    var UIFareremark = (function ($) {

        UIFareremark = function (options) {
            var that = this;

            that.data_possible_fields = ['order_hash', 'order_passenger_hash', 'search_hash',
                'exchange_pricing_passenger_hashes', 'exchange_pricing_segment_hash', 'exchange_pricing_desired_date', 'exchange_pricing_desired_variant_hash'
            ];

            that.icons = {
                loading: '<i class="fa fa-spinner fa-spin"></i>',
            };

            that.class = {
                fareremak_wrapper: 'js-fareremark-wrapper',
                fareremark_content_wrapper: 'fareremark-content-wrapper',
                fareremark_content: 'js-fareremark-content',
                reset: 'reset',
                preline: 'preline'
            };

            that.options = options;

            if (!that.options['order_hash'] && !that.options['search_hash']) {
                throw new Error('Order or search hash\'s is required');
            }

            that.href = $.sa.build_url('fareremark');

            that.fareremark_data = that.__getFareremarkData();

            that.options['header_title'] = (that.options['header_title'] || $.sa.locales['fare_rules']);
            that.options['content'] = (that.options['content'] || that.icons.loading);

            that.init();
        }

        UIFareremark.prototype.init = function () {
            var that = this;

            that.initModal();
        };

        UIFareremark.prototype.initModal = function () {
            var that = this;

            that.options['onOpen'] = (that.options['onOpen'] || function ($modal_wrapper, modal) {
                var href = that.href;

                $.post(href, that.fareremark_data, function (res) {
                    var $modal_content = $modal_wrapper.find('.' + modal.class.content+':not(.scroll-wrapper)');
                    if (res && res.status === 'ok' && res.data) {
                        $modal_content.html(that.__buildFareremarkContent(res.data));
                    } else {
                        $modal_content.html($.sa.locales['something_went_wrong']);
                    }
                });
            });

            $.uiModal(that.options);
        };

        UIFareremark.prototype.__buildFareremarkContent = function (fareremarks) {
            var that = this,
                $wrapper = $('<div />').addClass(that.class.fareremak_wrapper),
                $fareremark_content_wrapper = $('<div />').addClass(that.class.fareremark_content_wrapper),
                hr = document.createElement('hr');

            $.each(fareremarks, function (i, fareremark) {
                var fareremark_content = document.createElement('div');
                fareremark_content.classList.add(that.class.fareremark_content);
                fareremark_content.setAttribute('data-index', i);

                var fareremark_pre = document.createElement('pre');
                fareremark_pre.classList.add(that.class.reset, that.class.preline);
                fareremark_pre.innerHTML = fareremark['remark'];

                fareremark_content.appendChild(fareremark_pre);
                $fareremark_content_wrapper.append(fareremark_content);
                if (i < fareremarks.length - 1) {
                    $fareremark_content_wrapper.append(hr);
                }
            });

            $wrapper.append($fareremark_content_wrapper);
            return $wrapper;
        };

        UIFareremark.prototype.__getFareremarkData = function () {
            var that = this,
                fareremark_data = {};

            $.each(that.data_possible_fields, function (i, field) {
                if (that.options[field]) {
                    fareremark_data[field] = that.options[field];
                }
            });

            return fareremark_data;
        };

        return UIFareremark;
    })($);

    $.uiFareremark = function (plugin_options) {
        plugin_options = (typeof plugin_options === 'object' ? plugin_options : {});
        var options = $.extend(true, {}, plugin_options);
        return new UIFareremark(options);
    };
})(jQuery);